<template>
  <resource-search @delete="() => this.$emit('delete')"  @input="id => this.$emit('input', id)" module="templates" :show-delete="showDelete" :error-feed="errorFeed" :error-key="errorKey" :wait-for-input="waitForInput" :key="value.id" :fetch-params="extraFetchParams" v-model="value">
    <template #popover-list="{ result }">
      <p class="font-weight-bold mb-0  w-100-m-1">{{ result.name }}</p>
    </template>

    <template #selected="{ selected }">
      <p class="font-weight-bold mb-0  w-100-m-1">{{ selected.name }}</p>
    </template>
  </resource-search>
</template>

<script>
import ResourceSearch from './ResourceSearch.vue'
import momentMixin from '../mixins/momentMixin'

export default {
  mixins: [momentMixin],
  components: { ResourceSearch },
  props: {
    showDelete: {
      type: Boolean,
      default: false,
    },
    waitForInput: {
      type: Boolean,
      default: true,
    },
    errorFeed: Object,
    errorKey: String,
    type: String,
    value: Object,
  },
  computed: {
    extraFetchParams() {
      var returnParams = {};

      return returnParams;
    }
  },
}
</script>

<style>

</style>